export default {
    JAN: {
        code: 'jan',
        value: '01'
    },
    FEV: {
        code: 'fev',
        value: '02'
    },
    MAR: {
        code: 'mar',
        value: '03'
    },
    APR: {
        code: 'apr',
        value: '04'
    },
    MAY: {
        code: 'may',
        value: '05'
    },
    JUN: {
        code: 'jun',
        value: '06'
    },
    JUL: {
        code: 'jul',
        value: '07'
    },
    AUG: {
        code: 'aug',
        value: '08'
    },
    SEP: {
        code: 'sep',
        value: '09'
    },
    OCT: {
        code: 'oct',
        value: '10'
    },
    NOV: {
        code: 'nov',
        value: '11'
    },
    DEC: {
        code: 'dec',
        value: '12'
    }
};


// WEBPACK FOOTER //
// ./src/enums/Month.js